import { combineReducers } from 'redux';
import orders from 'redux/reducers/orders';

const rootReducer = combineReducers({
  orders
});

export default rootReducer;
